module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "unused",
    staticClass: "unused"
  }, [(_vm.couponsFn.length > 0) ? _c('div', {
    ref: "Content",
    staticClass: "unusedContent",
    class: _vm.addStateBut ? 'unusedContentFixe' : ''
  }, _vm._l((_vm.couponsFn), function(item, index) {
    return _c('xk-couponMod', {
      key: index,
      attrs: {
        "type": item.type,
        "sum": item.sum,
        "title": item.title,
        "startTime": item.startTime,
        "endTime": item.endTime,
        "overdueTime": item.overdueTime,
        "useState": 1,
        "couponType": item.couponType,
        "serviceType": item.servicetype
      }
    })
  }), 1) : _c('div', {
    staticClass: "wuyouhuiquan"
  }, [_c('h2', [_vm._v("暂无优惠券")])]), _vm._v(" "), _c('div', {
    staticClass: "addCoupon",
    class: _vm.addStateBut ? 'fixe' : '',
    on: {
      "click": _vm.addCouponFn
    }
  }, [_c('span', [_vm._v("添加优惠券")])]), _vm._v(" "), (_vm.addState) ? _c('xk-input-box', {
    attrs: {
      "title": '添加优惠券',
      "closeState": true
    },
    on: {
      "click": _vm.addCouponFn
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couponNum),
      expression: "couponNum"
    }],
    attrs: {
      "placeholder": "请输入优惠券编码"
    },
    domProps: {
      "value": (_vm.couponNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.couponNum = $event.target.value
      }, _vm.couponNumFn]
    }
  })])]) : _vm._e(), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  }), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hintBox', {
    attrs: {
      "time": 1500,
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e92ab89","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mewallet/coupon/unused.vue
// module id = 535
// module chunks = 0